import axios from "axios";

document.addEventListener('DOMContentLoaded', function () {

    let ajaxTable = document.querySelector('[ajax-table]');
    if (ajaxTable) {
        let resultFoundContainer = document.querySelector('[at-total]'),
            linksContainer = document.querySelector('[at-pagination]'),
            url = ajaxTable.getAttribute('ajax-table'),
            ajaxTableManager = {
                isBusy: false,
                hasChanges: false,
                prevData: {},

                submitButton: document.querySelector('[at-submit]'),
                resetButton: document.querySelector('[at-reset]'),

                inputs: {
                    items: [...document.querySelectorAll('[at-input]')],
                    data() {
                        let data = {};
                        this.items.forEach(input => {
                            data[input.name] = input.value;
                        })
                        return data;
                    },
                    reset() {
                        this.items.forEach(input => {
                            if (input.value !== '') {
                                ajaxTableManager.hasChanges = true;
                            }
                            input.value = '';
                        });
                    },
                    init() {
                        this.items.forEach(input => {
                                input.addEventListener('change', function () {
                                    ajaxTableManager.hasChanges = true;
                                    if (!input.dataset.hasOwnProperty('static')) {
                                        ajaxTableManager.load();
                                    }
                                })
                                input.addEventListener('keyup', function () {
                                    ajaxTableManager.hasChanges = true;
                                    if (!input.dataset.hasOwnProperty('static')) {
                                        ajaxTableManager.load();
                                    }
                                })
                        });
                    }
                },
                selects: {
                    items: [...document.querySelectorAll('[at-select]')],
                    data() {
                        let data = {};
                        this.items.forEach(select => {
                            data[select.name.replace('[]', '')] = select.value;
                        })
                        return data;
                    },
                    reset() {
                        this.items.forEach(select => {
                            if (select.value !== '') {
                                ajaxTableManager.hasChanges = true;
                            }
                            select.value = ''
                        });
                    },
                    init() {
                        this.items.forEach(select => {
                            select.addEventListener('change', function () {
                                ajaxTableManager.hasChanges = true;
                                if (!select.dataset.hasOwnProperty('static')) {
                                    ajaxTableManager.load();
                                }
                            })
                        });
                    }
                },
                radios: {
                    items: [...document.querySelectorAll('[at-radio]')],
                    data() {
                        let data = {};
                        document.querySelectorAll('[at-radio]:checked').forEach(radio => {
                            data[radio.name] = radio.value;
                        })
                        return data;
                    },
                    reset() {
                        this.items.forEach(radio => {
                            if (radio.checked !== false) {
                                ajaxTableManager.hasChanges = true;
                            }
                            radio.checked = false
                        });
                    },
                    init() {
                        this.items.forEach(checkbox => {
                            checkbox.addEventListener('change', function () {
                                ajaxTableManager.hasChanges = true;
                                ajaxTableManager.load();
                            })
                        });
                    }
                },

                data() {
                    return Object.assign(
                        this.inputs.data(),
                        this.selects.data(),
                        this.radios.data()
                    )
                },
                init() {
                    this.inputs.init()
                    this.selects.init()
                    this.radios.init()

                    this.resetButton?.addEventListener('click', () => {
                        this.reset();
                        if (this.hasChanges) {
                            this.load();
                        }
                        this.hasChanges = false;
                    })

                    this.submitButton?.addEventListener('click', () => {
                        if (this.hasChanges) {
                            this.load();
                            this.hasChanges = false;
                        }
                    })

                    this.initPagination();
                },
                reset() {
                    this.inputs.reset();
                    this.selects.reset();
                },
                preload() {
                    ajaxTable.innerHTML = "Загрузка...";
                    if (linksContainer) {
                        linksContainer.innerHTML = '';
                    }
                },
                initPagination() {
                    linksContainer && linksContainer.querySelectorAll('a.pagination-button,a.pagination-item').forEach(link => {
                        link.addEventListener('click', event => {
                            event.preventDefault();
                            this.load(link.dataset.page);
                        })
                    })
                },

                pushHistory(page = 0) {
                    function asParam(key, value) {
                        if (value) {
                            switch (typeof value) {
                                case 'object' :
                                    return value.map(val => `${key}[]=${val}`).join('&');
                                default:
                                    return `${key}=${value}`;
                            }
                        }
                        return null;
                    }


                    let data = this.data()
                    /** Если номер страницы больше 1, то в query добавляем параметр*/
                    if (page > 1) {
                        Object.assign(data, { page: page.toString() })
                    }
                    let params = Object.keys(data).map(key => asParam(key, data[key])).filter(string => !!string).join('&');

                    history.pushState(data, '', window.location.pathname + (params.length > 0 ? '?' + params : ''))
                },
                load(page = 0, replaceItems = true, additionalData = {}, useLastData = false) {
                    let data = {};
                    if (useLastData) {
                        data = this.prevData;
                        data = Object.assign(data, this.columns.data());
                    } else {
                        this.prevData = data = this.data();
                    }
                    data = Object.assign(data, additionalData, {page: page});

                    if (replaceItems) {
                        if (page > 0) {
                            document.querySelector('main .content').scrollIntoView({behavior: "smooth", inline: 'start'});
                        }
                    }
                    axios.get(url, {params: data})
                        .then(result => {
                            let response = result.data

                            if (replaceItems) {
                                ajaxTable.innerHTML = response.data.items;
                            } else {
                                ajaxTable.innerHTML += response.data.items;
                            }

                            if (resultFoundContainer) {
                                resultFoundContainer.innerHTML = response.data.resultsFoundText;
                            }
                            if (linksContainer) {
                                linksContainer.innerHTML = response.data.links;
                            }
                            this.initPagination();
                            ajaxTable.dispatchEvent(new Event('loaded'));
                            this.pushHistory(page);
                        })
                },
            };

        ajaxTableManager.init();
        ajaxTable.ajaxTableManager = ajaxTableManager;
    }
})
